import draw_polyline from '../draw_line_string'
import * as algorithm from './lib/algorithm/index'
import * as Constants from '../../constants';
import doubleClickZoom from '../../lib/double_click_zoom'
import createVertex from '../../lib/create_vertex';

const DrawPolylineShape = { ...draw_polyline }

DrawPolylineShape.onSetup = function () {
    const line = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {
            name: this.name,
            isCustom: true,
            type: this.type,
            coordinates: [],
            'line-color': '#54A6F2',
            'line-width': 2,
            opacity: 1,
            visible: true,
            description: "",
            'properties-dictionary': [
                { key: 'name', label: '名称', type: 'string' },
                { key: 'line-color', label: '颜色', type: 'color' },
                { key: 'line-width', label: '宽度', type: 'number', step: 0.1, min: 0 },
                { key: 'opacity', label: '透明度', type: 'number', step: 0.1, min: 0, max: 1 },
                { key: 'description', label: '说明', type: 'textArea' }
            ]
        },
        geometry: {
            type: Constants.geojsonTypes.LINE_STRING,
            coordinates: []
        }
    });

    this.addFeature(line);

    this.clearSelectedFeatures();
    doubleClickZoom.disable(this);
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POLYGON);
    this.setActionableState({
        trash: true
    });

    return {
        line,
        algorithmName: this.algorithmName,
        fixedPointCount: this.fixedPointCount,
        currentVertexPosition: 0,
    };
}

DrawPolylineShape.clickAnywhere = function (state, e) {
    state.currentVertexPosition++;
    state.line.properties.coordinates.push([e.lngLat.lng, e.lngLat.lat]);
    state.line.setCoordinates(algorithm[state.algorithmName](state.line.properties.coordinates));
    if (state.currentVertexPosition >= state.fixedPointCount) {
        // 结束绘制
        this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] }, { silent: false });
    }
}

DrawPolylineShape.onMouseMove = function (state, e) {
    if (state.currentVertexPosition > 0) {
        state.line.setCoordinates(algorithm[state.algorithmName]([].concat(state.line.properties.coordinates, [[e.lngLat.lng, e.lngLat.lat]])))
    }
}

DrawPolylineShape.toDisplayFeatures = function (state, geojson, display) {
    const isActiveLine = geojson.properties.id === state.line.id;
    geojson.properties.active = (isActiveLine) ? Constants.activeStates.ACTIVE : Constants.activeStates.INACTIVE;
    if (!isActiveLine) return display(geojson);
    // Only render the line if it has at least one real coordinate
    if (geojson.geometry.coordinates.length < 2) return;
    geojson.properties.meta = Constants.meta.FEATURE;

    geojson.properties.user_coordinates.forEach((coordinate, index) => {
        display(createVertex(state.line.id, coordinate, `0.${index}`, false));
    })

    return display(geojson);
}

DrawPolylineShape.onStop = function (state) {
    this.updateUIClasses({ mouse: Constants.cursors.NONE });
    doubleClickZoom.enable(this);
    this.activateUIButton();

    // check to see if we've deleted this feature
    if (this.getFeature(state.line.id) === undefined) return;
    //remove last added coordinate
    //state.line.removeCoordinate(`0.${state.currentVertexPosition}`);
    if (state.line.isValid()) {
        this.map.fire(Constants.events.CREATE, {
            features: [state.line.toGeoJSON(true)]
        });
    } else {
        this.deleteFeature([state.line.id], { silent: true });
        this.changeMode(Constants.modes.SIMPLE_SELECT, {}, { silent: true });
    }
};

// export default DrawPolylineShape;

/**
 * 多个点的polygon图形，双击结束
 * @param {*} opts 
 * @param {String} opts.type 类型 用draw_${type}调用
 * @param {String} opts.name 名字 用于编辑面板上展示
 * @param {Number} opts.fixedPointCount 骨骼点数量
 * @returns 
 */
const polylineShapeFractory = function (opts) {
    const target = { ...DrawPolylineShape }
    target.name = opts.name
    target.type = opts.type
    target.algorithmName = `${opts.type}_algorithm`
    target.fixedPointCount = opts.fixedPointCount
    return target
}

export default polylineShapeFractory;